module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAABKUlEQVQokY3RsUqcURAF4G93f9dGMeAKSsAgaKo8goVvYBotbBS0zgNoZeULRK3UxiKxtJMt1NZYyIpFIIILVsoqiKCsJqb4r3iVu+qBCzNn5h7OzBSq1eo2+nDnCZ3YxaQ3kOETpnAU8V3YwgFWW/x9wGGGc9TRiIoNDGEDY4Grox29IS9iIUMBHdHnYXzET4xH/Ofg7FfE7RQT1pr4gbmI+4rf8nEfUcJDlhDYC/ZOUcMJVvDF8z2VUEg5GMZ3XGAziBQwg4mXzSkHV7jEMkbRg0UM4Ow9ArXw4AP6wwhJpARGMI+/GERZfoEMa+G9KrCP6RDPyu/+LeQXrRzcRtw1/oT4GPdRHqOJfxm65bOWE03raGtRK6OSye+9hJtE06V8F5VErYjSf3vsO9ZxTZiOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/17.png
// module id = Nhm2
// module chunks = 0